import { createContext, useCallback, useMemo, useState } from "react";
import { Api } from "../utils/api";

const RoadmapDetailContext = createContext()

export const RoadmapDetailsProvider = ({ children }) => {

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)



    const getRoadmapdetails = useCallback(async (roadmaproute) => {
        setLoading(true)
        setError(null)
        try {
            const res = await Api.post("/development/route-details", { roadmaproute });
           
            
            return res.data
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }

    }, [])

    const value = useMemo(() => ({
        loading,
        error,
        getRoadmapdetails,
    }), [loading, error, getRoadmapdetails]);

    return (
        <RoadmapDetailContext.Provider
        value={value}
        >{children}</RoadmapDetailContext.Provider>
    )
}

    export default RoadmapDetailContext
